module.exports = __webpack_public_path__ + "media/images/flags/4x3/shn-20ec88cae319c396eb1ff38d25cab33e.svg";